import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { IoChevronBack, IoChevronForward, IoClose } from "react-icons/io5";
import { MdDownload } from "react-icons/md";
import { iconsDocs } from "../../services/icones-fichiers";
import { isImageFormat } from "../../services/normalizeContenu";
import "../../assets/css/component-media-gallery.css";

const VIDEO_FORMATS = ["mp4", "mov", "avi", "webm"];

export default function FilePreviewModal({ files, initialIndex, isOpen, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  useEffect(() => {
    if (isOpen) setCurrentIndex(initialIndex || 0);
  }, [isOpen, initialIndex]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === "ArrowLeft" && currentIndex > 0)
        setCurrentIndex((i) => i - 1);
      else if (e.key === "ArrowRight" && currentIndex < files.length - 1)
        setCurrentIndex((i) => i + 1);
      else if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, currentIndex, files.length, onClose]);

  if (!isOpen || !files || files.length === 0) return null;

  const current = files[currentIndex];
  const isImage = isImageFormat(current.format);
  const isVideo = VIDEO_FORMATS.includes(current.format?.toLowerCase());

  const handleDownload = (e) => {
    e.stopPropagation();
    const link = document.createElement("a");
    link.href = current.fileUrl;
    link.download = current.nom || "fichier";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const ext = current.format?.toLowerCase();
  const iconData = iconsDocs.find((icon) => icon.extension === ext);
  const fileIcon = iconData ? iconData.icon : iconsDocs[iconsDocs.length - 1].icon;

  return createPortal(
    <div className="media-gallery-backdrop" onClick={onClose}>
      <button className="media-gallery-close" onClick={onClose}>
        <IoClose />
      </button>

      <span className="media-gallery-counter">
        {currentIndex + 1} / {files.length}
      </span>

      <button className="file-preview-download" onClick={handleDownload}>
        <MdDownload />
      </button>

      {currentIndex > 0 && (
        <button
          className="media-gallery-arrow media-gallery-arrow--left"
          onClick={(e) => {
            e.stopPropagation();
            setCurrentIndex((i) => i - 1);
          }}
        >
          <IoChevronBack />
        </button>
      )}

      <div
        className="media-gallery-content"
        onClick={(e) => e.stopPropagation()}
      >
        {isImage ? (
          <img src={current.fileUrl} alt={current.nom} />
        ) : isVideo ? (
          <video src={current.fileUrl} controls autoPlay />
        ) : (
          <div className="file-preview-doc">
            <div className="file-preview-doc-icon">{fileIcon}</div>
            <div className="file-preview-doc-name">{current.nom}</div>
            <div className="file-preview-doc-size">{current.taille}</div>
            <button
              className="file-preview-doc-download-btn"
              onClick={handleDownload}
            >
              <MdDownload style={{ fontSize: "1.1rem" }} /> Telecharger
            </button>
          </div>
        )}
      </div>

      {currentIndex < files.length - 1 && (
        <button
          className="media-gallery-arrow media-gallery-arrow--right"
          onClick={(e) => {
            e.stopPropagation();
            setCurrentIndex((i) => i + 1);
          }}
        >
          <IoChevronForward />
        </button>
      )}
    </div>,
    document.body
  );
}
